module.exports = __webpack_public_path__ + "static/media/back-seat.bd7e89bc.jpg";